// src/components/Solucao.js
import React from 'react';
import './Solucao.css';

const Solucao = () => {
  const beneficios = [
    { icon: 'fas fa-syringe', title: 'Controle preciso do calendário vacinal', description: 'Nunca mais perca prazos de vacinação com alertas automáticos.' },
    { icon: 'fas fa-search-location', title: 'Rastreabilidade completa do rebanho', description: 'Acompanhe cada animal individualmente com identificação única.' },
    { icon: 'fas fa-bell', title: 'Alertas automáticos para vacinas e tratamentos', description: 'Receba notificações no momento certo para cada procedimento.' },
    { icon: 'fas fa-chart-bar', title: 'Relatórios detalhados para gestão eficiente', description: 'Tome decisões baseadas em dados com relatórios completos.' },
    { icon: 'fas fa-certificate', title: 'Valorização do rebanho com certificação digital', description: 'Comprove a saúde do rebanho e aumente o valor de mercado.' }
  ];

  return (
    <section id="solucao" className="section">
      <div className="container">
        <span className="section-eyebrow">A Solução</span>
        <h2 className="section-title">Tecnologia que Transforma a Pecuária</h2>
        <p className="section-subtitle">Desenvolvemos uma solução completa baseada em microchip para identificação, rastreamento e gestão digital da saúde animal. Cada animal recebe uma identidade única e permanente, com histórico completo de vacinas, tratamentos e localização. Tudo acessível em tempo real através de uma plataforma intuitiva.</p>

        <h3 className="beneficios-titulo">Benefícios da Nossa Solução</h3>
        
        <div className="beneficios-container">
          {beneficios.map((beneficio, index) => (
            <div key={index} className="beneficio-card">
              <div className="beneficio-icon">
                <i className={beneficio.icon}></i>
              </div>
              <h4>{beneficio.title}</h4>
              <p>{beneficio.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solucao;